import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const DragContainer = styled.div`
  position: relative;
  width: fit-content;
`;

export const Counter = styled.div`
    z-index: 200;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: ${C.DARK_ORANGE};
    text-align: center;
    position: absolute;
    right: 0px;
    top: -12px;
`;

export const Number = styled.div`
    margin-top: 3px;
    font-size: 15px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    color: ${C.WHITE};
`;


export const Preview = styled.div`
  opacity: 0.7;
`;